"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.file = exports.deficiency = exports["default"] = exports.comment = void 0;
var comment = exports.comment = 'comment';
var deficiency = exports.deficiency = 'deficiency';
var file = exports.file = 'file';
var _default = exports["default"] = {
  comment: comment,
  deficiency: deficiency,
  file: file
};